import { render, staticRenderFns } from "./FooterYjjM.vue?vue&type=template&id=09612fd1&scoped=true&"
import script from "./FooterYjjM.vue?vue&type=script&lang=js&"
export * from "./FooterYjjM.vue?vue&type=script&lang=js&"
import style0 from "./FooterYjjM.vue?vue&type=style&index=0&id=09612fd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09612fd1",
  null
  
)

export default component.exports